import React from "react";
import ReactHtmlParser from "html-react-parser";
import { ICustomCodeData } from "repoV2/interfaces/customCodes/ICustomCode";

type ICustomCodeElement = ({
    children,
}: {
    children: React.ReactNode;
}) => JSX.Element;

export const CustomCodeSection = ({
    position,
    codes,
    Section,
    Title,
}: {
    position: number;
    codes: ICustomCodeData[];
    Section: ICustomCodeElement;
    Title?: ICustomCodeElement;
}) => {
    const _codes = codes.filter(code => code.code_position?.includes(position));

    return (
        <>
            {_codes.map(code => (
                <Section key={code.uuid}>
                    {code.name && Title && <Title>{code.name}</Title>}
                    {ReactHtmlParser(code.code_snippet || "")}
                </Section>
            ))}
        </>
    );
};

CustomCodeSection.defaultProps = {
    Title: null,
};
